import { useState, useEffect } from 'react';
import EncounterListItem from './EncounterListItem'

const EncounterList = ({currentEncounter, setCurrentEncounter, handleSaveEncounter, turnNum, handleUploadMonsterImage, selectedIndex, handleRemoveFromSelectedIndex, clickEncounterCreatureX, resort, quickEdit, socket}) => {
    const [currentEncounterCreatures, setCurrentEncounterCreatures] = useState(currentEncounter.creatures);
    const [effectDuration, setEffectDuration] = useState('∞');
    const [conditionDuration, setConditionDuration] = useState('∞');

    useEffect(() => {
        setCurrentEncounterCreatures([...currentEncounter.creatures])
    }, [currentEncounter.creatures])

    useEffect(() => {
        setPlayerViewOnCreatureChange()
        // eslint-disable-next-line
    }, [currentEncounterCreatures])

    const setPlayerViewOnCreatureChange = () => {
        handleSaveEncounter()
    }

    return (
        <div className='encounterCreaturesList'>
            {currentEncounterCreatures.map((creatureListItem, index) => (
                <EncounterListItem key={creatureListItem.creatureGuid} currentEncounter={currentEncounter} creatureListItem={creatureListItem} setCurrentEncounter={setCurrentEncounter} index={index} isTurn={index+1 === turnNum} handleUploadMonsterImage={handleUploadMonsterImage} resort={resort} setPlayerViewOnCreatureChange={setPlayerViewOnCreatureChange} selectedIndex={selectedIndex} handleRemoveFromSelectedIndex={handleRemoveFromSelectedIndex} clickEncounterCreatureX={clickEncounterCreatureX} quickEdit={quickEdit} effectDuration={effectDuration} setEffectDuration={setEffectDuration} conditionDuration={conditionDuration} setConditionDuration={setConditionDuration} socket={socket}/>
            ))}
        </div>
    );
}

export default EncounterList;